export default {
  ADD_FAVORITE_ACCOUNT: "ADD_FAVORITE_ACCOUNT",
  ADD_FAVORITE_PRODUCT_GROUP: "ADD_FAVORITE_PRODUCT_GROUP",
  ADD_FAVORITE_OPPORTUNITY: "ADD_FAVORITE_OPPORTUNITY",
  ADD_NOTIFICATION: "ADD_NOTIFICATION",
  ADVANCE_CURRENT_PAGE: "ADVANCE_CURRENT_PAGE",
  CLEAR_ENTRIES: "CLEAR_ENTRIES",
  CLEAR_HISTORY_FILTERS: "CLEAR_HISTORY_FILTERS",
  DELETED_ENTRY: "DELETED_ENTRY",
  DELETE_ENTRY: "DELETE_ENTRY",
  DELETE_FAVORITE_ACCOUNT: "DELETE_FAVORITE_ACCOUNT",
  DELETE_FAVORITE_PRODUCT_GROUP: "DELETE_FAVORITE_PRODUCT_GROUP",
  DELETE_FAVORITE_OPPORTUNITY: "DELETE_FAVORITE_OPPORTUNITY",
  DELETING_ENTRY: "DELETING_ENTRY",
  DISMISS_NOTIFICATION: "DISMISS_NOTIFICATION",
  FETCHED_ENTRIES: "FETCHED_ENTRIES",
  FETCHING_ENTRIES: "FETCHING_ENTRIES",
  FETCH_CATEGORIES_FULFILLED: "FETCH_CATEGORIES_FULFILLED",
  FETCH_INTERLOCKS_FULFILLED: "FETCH_INTERLOCKS_FULFILLED",
  FETCH_DEFAULT_SR_FULFILLED: "FETCH_DEFAULT_SR_FULFILLED",
  FETCH_SERVICE_REQUESTS_FULFILLED: "FETCH_SERVICE_REQUESTS_FULFILLED",
  FETCH_USER_FAVORITES_FULFILLED: "FETCH_USER_FAVORITES_FULFILLED",
  HISTORY_FILTER_MODAL_OPEN: "HISTORY_FILTER_MODAL_OPEN",
  HISTORY_FILTER_MODAL_CLOSE: "HISTORY_FILTER_MODAL_CLOSE",
  HISTORY_FILTER_MODAL_TOGGLE: "HISTORY_FILTER_MODAL_TOGGLE",
  LOGIN_USER: "LOGIN_USER",
  LOGOUT_USER: "LOGOUT_USER",
  REPORT_ERROR_IN_PROGRESS: "REPORT_ERROR_IN_PROGRESS",
  REPORT_ERROR_SUCCESS: "REPORT_ERROR_SUCCESS",
  SET_API_FILTERS: "SET_API_FILTERS",
  SET_API_TOKENS: "SET_API_TOKENS",
  SET_DAY_GROUPS: "SET_DAY_GROUPS",
  SET_DURATION: "SET_DURATION",
  SET_END_DATE: "SET_END_DATE",
  SET_ENTRIES: "SET_ENTRIES",
  SET_ENTRY: "SET_ENTRY",
  SET_HAS_MORE_ENTRIES: "SET_HAS_MORE_ENTRIES",
  SET_HISTORY_ALL_UNTRACKED: "SET_HISTORY_ALL_UNTRACKED",
  SET_HISTORY_CONTEXT: "SET_HISTORY_CONTEXT",
  SET_HISTORY_FILTERS: "SET_HISTORY_FILTERS",
  SET_MOST_RECENT_ENTRY: "SET_MOST_RECENT_ENTRY",
  SET_TOTAL_HOURS: "SET_TOTAL_HOURS",
  SET_INITIAL_DATE: "SET_INITIAL_DATE",
  SET_ROLES: "SET_ROLES",
  SET_SETTINGS_TOGGLE: "SET_SETTINGS_TOGGLE",
  SET_SORT_DIR: "SET_SORT_DIR",
  SET_START_DATE: "SET_START_DATE",
  SET_USER: "SET_USER",
  SET_USER_PREFERENCES: "SET_USER_PREFERENCES",
  SET_USER_ROLE: "SET_USER_ROLE",
  SET_WORKED_HOURS: "SET_WORKED_HOURS",
  SET_WORKING_HOURS: "SET_WORKING_HOURS",
  SUBMITTED_ENTRY: "SUBMITTED_ENTRY",
  SUBMITTING_ENTRY: "SUBMITTING_ENTRY",
  SUBMIT_ENTRY: "SUBMIT_ENTRY",
  SUBMIT_GROUP_TOGGLE_ENTRIES: "SUBMIT_GROUP_TOGGLE_ENTRIES",
  SUBMIT_GROUP_TOGGLE_ENTRY: "SUBMIT_GROUP_TOGGLE_ENTRY",
  SUBMIT_GROUP_RESET: "SUBMIT_GROUP_RESET",
  UNSET_END_DATE: "UNSET_END_DATE",
  UNSET_START_DATE: "UNSET_START_DATE",
  USER_DATA_LOADED: "USER_DATA_LOADED",
  USER_DATA_LOADING: "USER_DATA_LOADING",
  USER_DATA_LOAD_FAILED: "USER_DATA_LOAD_FAILED",
  USER_UNAVAILABLE: "USER_UNAVAILABLE",
};



// WEBPACK FOOTER //
// ./app/actions/actions.js